import { fork } from 'redux-saga/effects';
import commonSaga from 'modules/common/sagas';
import generalSaga from 'modules/general/sagas';
import orderSaga from 'modules/order/sagas';
import accountManagementSaga from 'modules/accountManagement/sagas';

function* rootSaga() {
  yield fork(commonSaga);
  yield fork(generalSaga);
  yield fork(orderSaga);
  yield fork(accountManagementSaga);
}

export default rootSaga;
